import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import AuditingModal from '../patient/auditing/AuditingModal';
import { getPatientId } from '../../services/helpers';

export class AddTimeTrackingButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuditingModalOpen: false,
    };
  }

  handleCloseModal = (isOpened) => {
    this.setState({ isAuditingModalOpen: isOpened }, () => {
      if (!isOpened && this.props.onClose) {
        this.props.onClose();
      }
    });
  };

  renderAuditingActivityButton = (size = 'sm', margin = 'm-2') => {
    const {
      patient,
      isReadOnly = false,
    } = this.props;
    const patientId = getPatientId(patient);
    const { isAuditingModalOpen } = this.state;

    return (
      <Fragment>
        <Button
          size={size}
          className={margin}
          variant="primary"
          onClick={() => this.setState({
            isAuditingModalOpen: true,
          })}
          data-test="addTimeTracking_openAuditModalButton"
          disabled={isReadOnly}
        >
          <i className="mr-2 bi-plus-lg" />
          Add Time Tracking
        </Button>
        <AuditingModal
          patientId={patientId}
          initialActivity={null}
          isModalOpen={isAuditingModalOpen}
          setIsModalOpen={this.handleCloseModal}
          data-test="addTimeTracking_auditingModal"
        />
      </Fragment>
    );
  };

  render() {
    const { patient, size, margin } = this.props;

    return (
      <Fragment>
        {patient?.identifiers && (
          this.renderAuditingActivityButton(size, margin)
        )}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    patient: state.patient,
    isReadOnly: state.tenant && state.tenant.isReadOnly,
  };
}

export default connect(mapStateToProps)(AddTimeTrackingButton);
